/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { SVGIcons } from "cms/icons/svg-icons";
import { isTrue } from "utils/empty-exists";

const UnderlineStyleLink = (props) => {
    
    const { link, style } = props;
    const target = link?.is_external ? "_blank" : "_self";
    const isExternal = isTrue(link?.is_external);
    
    return (
        <a
            href={link?.url}
            className={`displayLink ${style} `}
            target={target}
            rel='noreferrer'
        >
            {link.text}
            {isExternal &&
                <>{" "}<SVGIcons.fields.LinkField /></>
            }
        </a>
    );
};

export { UnderlineStyleLink };
